function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PureComponent } from "react";
import Slider from "react-slick";
import BaseTemplate from "components/templates/base-template";
import BaseHeaderComponent from "segments/desktop/header/layouts/base-header/base-header-component";
import LongFooterComponent from "segments/desktop/footer/layouts/long-footer/long-footer-component";
import classnames from "classnames";
import VisibilitySensor from "react-visibility-sensor";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import { generateOnKeyDownHandler } from "client/services/accessibility/accessibility-service";
import CarouselNext from "static/svg/carousel-next.svg";
import CarouselPrev from "static/svg/carousel-prev.svg";
import { StyledPositionComponent } from "./position-component.scss";
import PictureComponent from "/components/core/picture/picture-component";
import { createApplicationFormWidget } from "/server/services/comeet-service/comeet-service";
import PositionTextComponent from "/components/pages/jobs-page/position-page/position-description/position-text/position-text.js";
import CandidatePrivacyNotice from "/components/pages/careers/position/candidate-privacy-notice/candidate-privacy-notice.js";
import { getDeptID, getLocationID } from "../careers-service.js";
import careersConfig from "../careers-config.json";
import SVGClock from "/static/svg/careers/clock.svg";
import SVGDribbleIcon from "/static/svg/careers/dribble.svg";
import SVGChevronRight from "/static/svg/careers/chevron-right.svg";
import { CAREER_KIND_BACK_TO_CARRER_PAGE_CTA, CAREER_KIND_BLOG_ITEM_CLICKED, CAREER_KIND_PODCAST_ITEM_CLICKED, CAREER_PAGE_CLICK, CAREER_POSITIONS_APPLY_NOW_BUTTON_IS_VISIBLE, CAREERS_POSITION_APPLY_NOW_BUTTON_CLICKED, CAROUSEL_ARROW_CLICKED } from "/constants/bigbrain-event-types";
import { DESCRIPTION, getCareersRootUrl, META_OVERRIDE, POSITION_TYPE_INTERNAL, TITLE } from "../careers-constants.js";
import { scrollTo } from "/services/dom-utils-service";
import { trackEvent } from "/services/bigbrain-service";
class PositionComponent extends PureComponent {
    componentDidMount() {
        createApplicationFormWidget();
    }
    copyUrlToClipboard() {
        const urlToShare = document.location.href;
        this.setState({
            linkCopied: true
        });
        // adapted from https://www.30secondsofcode.org/blog/s/copy-text-to-clipboard-with-javascript
        const el = document.createElement("textarea");
        el.value = urlToShare;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
    }
    toggleMobileAccordion(idx) {
        const { mobileAccordionsState } = this.state;
        const newAccordionState = mobileAccordionsState.slice();
        newAccordionState[idx] = !newAccordionState[idx];
        this.setState({
            mobileAccordionsState: newAccordionState
        });
    }
    onBlogItemClicked(blogUrl) {
        BigBrain("track", CAREER_PAGE_CLICK, {
            kind: CAREER_KIND_BLOG_ITEM_CLICKED,
            info1: blogUrl,
            placement: this.pageLoadUniqueId
        });
        return true;
    }
    onPodcastItemClicked(episodeName) {
        BigBrain("track", CAREER_PAGE_CLICK, {
            kind: CAREER_KIND_PODCAST_ITEM_CLICKED,
            info1: episodeName,
            placement: this.pageLoadUniqueId
        });
        return true;
    }
    onBackToCareersCTAClick() {
        BigBrain("track", CAREER_PAGE_CLICK, {
            kind: CAREER_KIND_BACK_TO_CARRER_PAGE_CTA
        });
    }
    onVisibilityChange(visible, data) {
        const { showGoToApplyForm, showGoToApplyFormEventSent } = this.state;
        // showing goto button only applu form seciton is not visible and is above us
        const newShowGoToApplyForm = !visible && data.bottom;
        if (showGoToApplyForm != newShowGoToApplyForm) {
            this.setState({
                showGoToApplyForm: newShowGoToApplyForm
            });
            if (!showGoToApplyFormEventSent) {
                trackEvent(CAREER_POSITIONS_APPLY_NOW_BUTTON_IS_VISIBLE);
                this.setState({
                    showGoToApplyFormEventSent: true
                });
            }
        }
    }
    scrollToApplyForm() {
        if (this._applySection) {
            scrollTo(this._applySection.offsetTop, 200);
            trackEvent(CAREERS_POSITION_APPLY_NOW_BUTTON_CLICKED);
        }
    }
    PrevArrow({ className, onClick }) {
        const onPrevArrowClick = ()=>{
            if (onClick) {
                trackEvent(CAROUSEL_ARROW_CLICKED, {
                    info3: "prev"
                });
                onClick();
            }
        };
        return /*#__PURE__*/ _jsx("button", {
            type: "button",
            className: classnames(className, "carousel-arrow-wrapper", "prev"),
            onClick: onPrevArrowClick,
            tabIndex: 0,
            onKeyDown: generateOnKeyDownHandler(onClick),
            children: /*#__PURE__*/ _jsx(CarouselPrev, {})
        });
    }
    NextArrow({ className, onClick }) {
        const onNextArrowClick = ()=>{
            if (onClick) {
                trackEvent(CAROUSEL_ARROW_CLICKED, {
                    info3: "next"
                });
                onClick();
            }
        };
        return /*#__PURE__*/ _jsx("button", {
            type: "button",
            className: classnames(className, "carousel-arrow-wrapper", "next"),
            onClick: onNextArrowClick,
            tabIndex: 0,
            onKeyDown: generateOnKeyDownHandler(onClick),
            children: /*#__PURE__*/ _jsx(CarouselNext, {})
        });
    }
    render() {
        const { id, positionData, positionsType } = this.props;
        const { mobileAccordionsState, showGoToApplyForm } = this.state;
        const deptID = getDeptID(positionData.department);
        const deptInfo = deptID ? careersConfig.departments.find((department)=>department.id === deptID) : null;
        const locationID = getLocationID(positionData.location);
        const locationInfo = locationID ? careersConfig.locations.find((location)=>location.id === locationID) : null;
        return /*#__PURE__*/ _jsxs(BaseTemplate, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, this.props), {
            enableHotjar: true
        }), this.buildMetaTags()), {
            children: [
                /*#__PURE__*/ _jsxs(StyledPositionComponent, {
                    className: "position-component",
                    children: [
                        /*#__PURE__*/ _jsx(BaseHeaderComponent, {}),
                        /*#__PURE__*/ _jsx("div", {
                            className: classnames("sticky-apply-button", {
                                visible: showGoToApplyForm
                            }),
                            onClick: ()=>this.scrollToApplyForm(),
                            children: "Apply to this job"
                        }),
                        /*#__PURE__*/ _jsx("section", {
                            className: "section section-position-heading",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "container has-text-centered",
                                children: [
                                    /*#__PURE__*/ _jsx("h1", {
                                        className: "title",
                                        children: positionData.title
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "position-subtitle",
                                        children: [
                                            deptInfo && /*#__PURE__*/ _jsxs("span", {
                                                className: "dept",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "circle",
                                                        style: {
                                                            background: deptInfo.color
                                                        }
                                                    }),
                                                    deptInfo.name
                                                ]
                                            }),
                                            positionData.employmentType && /*#__PURE__*/ _jsxs("span", {
                                                className: "etype",
                                                children: [
                                                    /*#__PURE__*/ _jsx(SVGClock, {
                                                        className: `clock-icon ${positionData.employmentType == "Full-time" ? "full-time" : "part-time"}`
                                                    }),
                                                    positionData.employmentType
                                                ]
                                            }),
                                            locationInfo && /*#__PURE__*/ _jsxs("span", {
                                                className: "city",
                                                children: [
                                                    /*#__PURE__*/ _jsx(PictureComponent, {
                                                        src: locationInfo.icon
                                                    }),
                                                    locationInfo.name
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        positionData != null && /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("section", {
                                    className: "section section-position-details",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "container",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "columns",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "column is-8",
                                                    children: /*#__PURE__*/ _jsx("section", {
                                                        className: "careeers-position-info",
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            className: "position-text",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "desktop-only",
                                                                    children: /*#__PURE__*/ _jsx(PositionTextComponent, {
                                                                        text: positionData.positionDescription
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: `accordion-holder ${mobileAccordionsState[0] ? "is-active" : ""}`,
                                                                    onClick: this.toggleMobileAccordion.bind(this, 0),
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "accordion-header has-mobile-padding",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("h2", {
                                                                                    children: this.getAboutRoleText()
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(SVGChevronRight, {})
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "accordion-content has-mobile-padding",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "mobile-only has-padding-0",
                                                                                    children: /*#__PURE__*/ _jsx(PositionTextComponent, {
                                                                                        text: positionData.positionDescription
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(PositionTextComponent, {
                                                                                    text: positionData.positionResponsibilities
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: `accordion-holder ${mobileAccordionsState[1] ? "is-active" : ""}`,
                                                                    onClick: this.toggleMobileAccordion.bind(this, 1),
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "accordion-header has-mobile-padding",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("h2", {
                                                                                    children: this.getExperienceText()
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(SVGChevronRight, {})
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "accordion-content has-mobile-padding",
                                                                            children: /*#__PURE__*/ _jsx(PositionTextComponent, {
                                                                                text: positionData.positionRequirements
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx("br", {}),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "has-mobile-padding",
                                                                    children: this.renderShareableLink()
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "column side-content desktop-only",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(VisibilitySensor, {
                                                            partialVisibility: true,
                                                            onChange: this.onVisibilityChange,
                                                            active: true,
                                                            scrollCheck: true,
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "comeet-widget-container",
                                                                ref: (el)=>this._applySection = el,
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "title",
                                                                        children: "Apply to this job"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("script", {
                                                                        type: "comeet-applyform",
                                                                        "data-position-uid": id,
                                                                        "data-field-phone-required": "false",
                                                                        "data-field-linkedin": "true",
                                                                        "data-require-profile": "any",
                                                                        "data-field-website": "false",
                                                                        "data-field-phone": "false",
                                                                        "data-field-website-required": "false",
                                                                        "data-field-coverletter": "false",
                                                                        "data-field-portfolio": "false",
                                                                        "data-field-personalnote": "false",
                                                                        "data-css-url": "https://monday.com/static/css/comeet-widget-style.css",
                                                                        "data-css-cache": "true",
                                                                        "data-color": "#323338",
                                                                        "data-button-text": "Apply to this job",
                                                                        "data-font-size": "16px",
                                                                        "data-button-font-size": "22px",
                                                                        "data-labels-position": "left",
                                                                        "data-button-color": "#009AFF"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("script", {
                                                            type: "comeet-social",
                                                            "data-position-uid": id,
                                                            "data-social-pinterest": "false"
                                                        }),
                                                        this.renderMailCVComponent(),
                                                        /*#__PURE__*/ _jsx(CandidatePrivacyNotice, {})
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("section", {
                                    className: "section section-mobile-apply mobile-only",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "comeet-widget-container",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "title",
                                                children: "Apply to this job"
                                            }),
                                            /*#__PURE__*/ _jsx("script", {
                                                type: "comeet-applyform",
                                                "data-position-uid": id,
                                                "data-field-phone-required": "false",
                                                "data-field-linkedin": "true",
                                                "data-require-profile": "any",
                                                "data-field-website": "false",
                                                "data-field-phone": "false",
                                                "data-field-website-required": "false",
                                                "data-field-coverletter": "false",
                                                "data-field-portfolio": "false",
                                                "data-field-personalnote": "false",
                                                "data-css-url": "https://monday.com/static/css/comeet-widget-style.css",
                                                "data-css-cache": "true",
                                                "data-color": "#323338",
                                                "data-button-text": "Apply to this job",
                                                "data-font-size": "16px",
                                                "data-button-font-size": "22px",
                                                "data-labels-position": "left",
                                                "data-button-color": "#009AFF"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("section", {
                                    className: "section section-mobile-share mobile-only",
                                    children: [
                                        /*#__PURE__*/ _jsx("script", {
                                            type: "comeet-social",
                                            "data-position-uid": id,
                                            "data-social-pinterest": "false"
                                        }),
                                        this.renderMailCVComponent()
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "disability-paragraph",
                                    dangerouslySetInnerHTML: {
                                        __html: careersConfig.disabilityText
                                    }
                                }),
                                !this.isInternalMobilityPage() && this.renderExternalPositionComponents(deptID, deptInfo),
                                /*#__PURE__*/ _jsx("section", {
                                    className: "section section-position-footer has-text-centered desktop-only",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        className: "button careers-rnd-btn",
                                        href: getCareersRootUrl(positionsType),
                                        onClick: ()=>this.onBackToCareersCTAClick(),
                                        children: "Back to careers page"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(LongFooterComponent, {})
            ]
        }));
    }
    constructor(props){
        super(props);
        _define_property(this, "isInternalMobilityPage", ()=>{
            const { positionsType } = this.props;
            return positionsType === POSITION_TYPE_INTERNAL;
        });
        _define_property(this, "getAboutRoleText", ()=>{
            return this.isInternalMobilityPage() ? "About the Role & Team" : "About The Role";
        });
        _define_property(this, "getExperienceText", ()=>{
            return this.isInternalMobilityPage() ? "Internal Requirements" : "Your Experience & Skills";
        });
        _define_property(this, "getDepartmentPodcastTitle", (deptInfo)=>{
            if (deptInfo.sfsTitle) return deptInfo.sfsTitle;
            return `${deptInfo.name} Playlist`;
        });
        _define_property(this, "buildMetaTags", ()=>{
            const { positionData } = this.props;
            const { socialTitle, socialDescription, department } = positionData;
            return _object_spread_props(_object_spread({}, META_OVERRIDE), {
                title: socialTitle ? `${socialTitle} | Apply today at monday.com` : TITLE,
                description: socialDescription || DESCRIPTION,
                noIndex: (department === null || department === void 0 ? void 0 : department.toLowerCase()) === "unlisted",
                noFollow: (department === null || department === void 0 ? void 0 : department.toLowerCase()) === "unlisted"
            });
        });
        _define_property(this, "renderMailCVComponent", ()=>{
            return /*#__PURE__*/ _jsxs("div", {
                className: "mail-cv-paragraph",
                children: [
                    "If you’re having trouble submitting this form, please send us an email with your CV and a link to the position at: ",
                    /*#__PURE__*/ _jsx("a", {
                        href: "mailto:jobs@monday.com",
                        children: "jobs@monday.com"
                    })
                ]
            });
        });
        _define_property(this, "renderPositionPageTeamImagesAsCarousel", (deptInfo)=>{
            const { PrevArrow, NextArrow } = this;
            return /*#__PURE__*/ _jsx("div", {
                className: "team-images-carousel-container",
                children: /*#__PURE__*/ _jsx(Carousel, {
                    items: deptInfo.positionPageTeamImages,
                    itemRenderer: (imgUrl)=>/*#__PURE__*/ _jsx(PictureComponent, {
                            className: "team-img",
                            src: imgUrl
                        }, imgUrl),
                    slidesToShow: 1,
                    autoplay: true,
                    autoplaySpeed: 10000,
                    dots: true,
                    infinite: true,
                    centerMode: false,
                    defaultIndex: 0,
                    arrows: true,
                    swipeToSlide: true,
                    prevArrow: /*#__PURE__*/ _jsx(PrevArrow, {}),
                    nextArrow: /*#__PURE__*/ _jsx(NextArrow, {})
                })
            });
        });
        _define_property(this, "renderPositionPageTeamImagesInAList", (deptInfo)=>{
            return /*#__PURE__*/ _jsx("div", {
                className: "team-images-container",
                children: deptInfo.positionPageTeamImages.map((imgUrl)=>/*#__PURE__*/ _jsx(PictureComponent, {
                        className: "team-img",
                        src: imgUrl
                    }, imgUrl))
            });
        });
        _define_property(this, "renderPositionPageTeamImages", (deptInfo)=>{
            if (!deptInfo.positionPageTeamImages || deptInfo.positionPageTeamImages.length === 0) return null;
            return deptInfo.positionPageTeamImages.length === 1 ? this.renderPositionPageTeamImagesInAList(deptInfo) : this.renderPositionPageTeamImagesAsCarousel(deptInfo);
        });
        _define_property(this, "renderExternalPositionComponents", (deptID, deptInfo)=>{
            const { id } = this.props;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    (deptInfo === null || deptInfo === void 0 ? void 0 : deptInfo.teamDescription) && /*#__PURE__*/ _jsx("section", {
                        className: "section section-team-details has-text-centered",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "containeraa",
                            children: [
                                /*#__PURE__*/ _jsxs("h2", {
                                    className: "title meet-the-title",
                                    children: [
                                        "Meet the ",
                                        deptInfo.name,
                                        " team"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "has-mobile-padding",
                                    children: /*#__PURE__*/ _jsx(PositionTextComponent, {
                                        text: deptInfo === null || deptInfo === void 0 ? void 0 : deptInfo.teamDescription
                                    })
                                }),
                                this.renderPositionPageTeamImages(deptInfo)
                            ]
                        })
                    }),
                    deptInfo && /*#__PURE__*/ _jsxs("section", {
                        className: "section section-startupforstartup has-text-centered",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "title has-mobile-narrow-padding",
                                children: "Listen to our team's playlist on Startup for Startup podcast"
                            }),
                            /*#__PURE__*/ _jsx("h2", {
                                className: "subtitle has-mobile-narrow-padding",
                                children: "Founders and members of the startup ecosystem share experience, advice, and tips"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "sfs-links-container has-text-left",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "columns",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "column is-half",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                onClick: ()=>this.onPodcastItemClicked(this.getDepartmentPodcastTitle(deptInfo)),
                                                href: deptInfo.sfsPlaylistUrl,
                                                className: "sfs-link",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "sfs-link-box",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("h4", {
                                                            children: this.getDepartmentPodcastTitle(deptInfo)
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "langs",
                                                            children: "Hebrew & English"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "platforms",
                                                            children: "Listen on:"
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "column is-half",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                onClick: ()=>this.onPodcastItemClicked("Who We Are - company culture"),
                                                href: "https://www.startupforstartup.com/playlists/startup-for-startup-who-we-are/",
                                                className: "sfs-link",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "sfs-link-box",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("h4", {
                                                            children: "Who We Are - company culture"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "langs",
                                                            children: "Hebrew & English"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "platforms",
                                                            children: "Listen on:"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    deptID == "design" && /*#__PURE__*/ _jsx("section", {
                        className: "section section-team-specific-content desktop-only",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "design-youtube-link is-block has-text-centered",
                                    children: [
                                        /*#__PURE__*/ _jsxs("h3", {
                                            className: "subtitle two-tone-title has-text-centered",
                                            children: [
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Watch Meytal & Evgeniy talk about"
                                                }),
                                                " our automations & integrations"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("iframe", {
                                            width: "800",
                                            height: "450",
                                            src: "https://www.youtube.com/embed/H_HsWAiCyvQ",
                                            frameBorder: "0",
                                            allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                                            allowFullScreen: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("a", {
                                    className: "design-instagram-link is-block",
                                    target: "_blank",
                                    href: "https://www.instagram.com/mondaydotcom/",
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ _jsxs("h3", {
                                            className: "subtitle two-tone-title has-text-centered",
                                            children: [
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Follow us on"
                                                }),
                                                " @monday.com.design ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "instagram"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(PictureComponent, {
                                            className: "image",
                                            src: "/static/img/careers/dept_photos/design-insta-banner.jpg"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("a", {
                                    className: "design-dribble-link is-block has-text-centered",
                                    target: "_blank",
                                    href: "https://dribbble.com/mondaydotcom",
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ _jsx(SVGDribbleIcon, {}),
                                        "More of monday.com designs on Dribble"
                                    ]
                                })
                            ]
                        })
                    }),
                    deptID == "sfs" && /*#__PURE__*/ _jsx("section", {
                        className: "section section-team-specific-content",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "container",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "design-youtube-link is-block has-text-centered",
                                children: [
                                    /*#__PURE__*/ _jsxs("h3", {
                                        className: "subtitle two-tone-title has-text-centered",
                                        children: [
                                            "Watch videos from our ",
                                            /*#__PURE__*/ _jsx("strong", {
                                                children: "Startup for Startup: Unplugged"
                                            }),
                                            " event"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("iframe", {
                                        width: "800",
                                        height: "450",
                                        src: "https://www.youtube.com/embed/-eCpGEfqnJo",
                                        frameBorder: "0",
                                        allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                                        allowFullScreen: true
                                    })
                                ]
                            })
                        })
                    }),
                    deptInfo && deptInfo.blogPosts && deptInfo.blogPosts.length > 0 && /*#__PURE__*/ _jsx("section", {
                        className: "section section-team-specific-content",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ _jsxs("h3", {
                                    className: "subtitle two-tone-title has-text-centered has-mobile-padding",
                                    children: [
                                        /*#__PURE__*/ _jsx("strong", {
                                            children: "Check out our team's articles"
                                        }),
                                        " on monday.com blog"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "columns desktop-only",
                                    children: deptInfo.blogPosts.map((blogPost)=>/*#__PURE__*/ _jsx("div", {
                                            className: "column is-4",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: blogPost.url,
                                                onClick: ()=>this.onBlogItemClicked(blogPost.url),
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card card-news",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "card-image",
                                                            children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                                className: "image",
                                                                src: blogPost.imageUrl
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "card-content",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("p", {
                                                                    children: blogPost.title
                                                                }),
                                                                /*#__PURE__*/ _jsx("footer", {
                                                                    className: "card-footer",
                                                                    children: /*#__PURE__*/ _jsx("p", {
                                                                        children: blogPost.author
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }, blogPost.url))
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mobile-only",
                                    children: /*#__PURE__*/ _jsx(Slider, {
                                        infinite: true,
                                        draggable: true,
                                        dots: true,
                                        arrows: false,
                                        speed: 1500,
                                        centerMode: true,
                                        infinite: false,
                                        centerPadding: "42px",
                                        pauseOnFocus: false,
                                        pauseOnHover: false,
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        adaptiveHeight: false,
                                        children: deptInfo.blogPosts.map((blogPost)=>/*#__PURE__*/ _jsx("a", {
                                                href: blogPost.url,
                                                onClick: ()=>this.onBlogItemClicked(blogPost.url),
                                                target: "_blank",
                                                className: "anchor-holder",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card card-news",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "card-image",
                                                            children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                                className: "image",
                                                                src: blogPost.imageUrl
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "card-content",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("p", {
                                                                    children: blogPost.title
                                                                }),
                                                                /*#__PURE__*/ _jsx("footer", {
                                                                    className: "card-footer",
                                                                    children: /*#__PURE__*/ _jsx("p", {
                                                                        children: blogPost.author
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, blogPost.url))
                                    })
                                })
                            ]
                        })
                    }),
                    deptID == "design" && /*#__PURE__*/ _jsx("section", {
                        className: "section section-team-specific-content mobile-only",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ _jsxs("a", {
                                    className: "design-instagram-link is-block",
                                    target: "_blank",
                                    href: "https://www.instagram.com/mondaydotcom/",
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ _jsxs("h3", {
                                            className: "subtitle two-tone-title has-text-centered",
                                            children: [
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Follow us on"
                                                }),
                                                " @monday.com.design ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "instagram"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(PictureComponent, {
                                            className: "image",
                                            src: "/static/img/careers/dept_photos/design-insta-banner.jpg"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("a", {
                                    className: "design-dribble-link is-block has-text-centered",
                                    target: "_blank",
                                    href: "https://dribbble.com/mondaydotcom",
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ _jsx(SVGDribbleIcon, {}),
                                        "More of monday.com designs on Dribble"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            });
        });
        _define_property(this, "renderShareableLink", ()=>{
            const { linkCopied } = this.state;
            const text = linkCopied ? "Link copied!" : "Copy shareable link";
            const onClickFunc = linkCopied ? null : this.copyUrlToClipboard;
            return /*#__PURE__*/ _jsx("a", {
                className: classnames("copy-shareable-link", {
                    "is-not-clicked": !linkCopied
                }),
                tabIndex: "0",
                onClick: onClickFunc,
                role: "button",
                children: text
            });
        });
        this.copyUrlToClipboard = this.copyUrlToClipboard.bind(this);
        this.onVisibilityChange = this.onVisibilityChange.bind(this);
        this.scrollToApplyForm = this.scrollToApplyForm.bind(this);
        // this.toggleMobileAccordion = this.toggleMobileAccordion.bind(this);
        this.state = {
            mobileAccordionsState: [
                false,
                false
            ],
            linkCopied: false,
            showGoToApplyForm: false,
            showGoToApplyFormEventSent: false
        };
    }
}
export { PositionComponent as default };
